module.exports = __webpack_public_path__ + "static/img/1038_small.eb32ef6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1038_small.png
// module id = bif+
// module chunks = 1